import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { formaterPrix } from '../services/format';

export default function MesCommandes() {
  const [commandes, setCommandes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function charger() {
      setLoading(true);
      try {
        const { data } = await api.get('/commandes');
        if (!mounted) return;
        setCommandes(data);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    charger();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="grid gap-4">
      <div>
        <div className="text-xs font-semibold uppercase tracking-widest text-gray-600">Compte</div>
        <div className="mt-2 text-xl font-bold text-gray-900">Mes commandes</div>
      </div>

      {loading ? (
        <div className="rounded-3xl border border-gray-200 bg-white p-8 text-sm text-gray-600">Chargement...</div>
      ) : null}

      {!loading && !commandes.length ? (
        <div className="rounded-3xl border border-gray-200 bg-white p-8 text-sm text-gray-600">Aucune commande.</div>
      ) : null}

      <div className="grid gap-3">
        {commandes.map((c) => (
          <div key={c.id} className="rounded-3xl border border-gray-200 bg-white p-5">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <div className="text-sm font-semibold text-gray-900">Commande #{c.id}</div>
                <div className="mt-1 text-xs text-gray-500">{new Date(c.date_commande).toLocaleString('fr-FR')}</div>
              </div>
              <div className="text-right">
                <div className="text-xs text-gray-600">Statut</div>
                <div className="text-sm font-semibold text-gray-900">{c.statut}</div>
              </div>
              <div className="text-right">
                <div className="text-xs text-gray-600">Total</div>
                <div className="text-sm font-bold text-gray-900">{formaterPrix(c.montant_total)}</div>
              </div>
            </div>
            <div className="mt-3 text-xs text-gray-500">Paiement: {c.methode_paiement}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
